import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import "../../styles/style.css";
import "../../styles/index.css";
import DeleteImage from "../../assets/images/delete.png";
import UploadIcon from "../../assets/images/upload-icon.png";
import { FiUploadCloud } from "react-icons/fi";
import { dataSource, deleteDataSource, uploadDatasource, searchDatasource } from '../../services/apiService';
import Loader from '../Loader/Loader';
import Pagination from '../pages/Pagination'; // Import Pagination component
import Swal from "sweetalert2";

const DataSource = () => {
  const [newDataSourceData, setDataSourceData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupQa, setShowPopupQa] = useState(false);
  const [showPopupQaDe, setShowPopupQaDe] = useState(false);
  const [showPopupDo, setShowPopupDo] = useState(false);
  const [showPopupIm, setShowPopupIm] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState();
  const [loading, setLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes in seconds
  const [isUploading, setIsUploading] = useState(false); // Tracks the file upload state
  const [searchTerm, setSearchTerm] = useState({
    search:'',
  });
  
  // Countdown logic
  /*useEffect(() => {
    let timer;
    if (isUploading) {
      timer = setTimeout(() => {
        if (timeLeft > 0) {
          setTimeLeft((prev) => prev - 1);
        } else {
          // Close popup after countdown ends
          setIsUploading(false);
          setLoading(false);
        }
      }, 1000); // Decrease time every second
    }
    return () => clearTimeout(timer); // Cleanup on unmount
  }, [timeLeft, isUploading]);*/

  // Format time from seconds to MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleFileChange = (e) => {
    setSelectedFiles(e.target.files[0]);
    const file = e.target.files[0];
      setFormData({
            ...formData,
            file: file,
          });
  };

  const fetchTableData = async () => {
    try {
      setLoading(true);
      const response = await dataSource();
      setDataSourceData(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching DataSource data:', error);
    }
  };
  
  useEffect(() => {
    fetchTableData();
  }, []);

    const [formData, setFormData] = useState({
      file: null,
    });
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState("");

    const handleDeleteDataSource = async (Id) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async(result) => {
        if (result.isConfirmed) {
          try {
            setLoading(true);
            await deleteDataSource(Id);
            fetchTableData();
            setLoading(false);
          } catch (error) {
            console.error('Error deleting DataSource:', error);
          }
        }
      });
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
        try {
          setLoading(true);
          await uploadDatasource(formData);
          setShowPopup(false);
          setShowPopupDo(false);
          setShowPopupIm(false);
          //setIsUploading(true);
          //setTimeLeft(120);
          fetchTableData();    
          setFormData({
            file: null,
          });
          setSelectedFiles(false);
          setLoading(false);
        } catch (error) {
          console.error("Failed to store data:", error.message);
          setErrorMessage(error.response?.data?.message || 'An error occurred');
        }
    };

  const handleInputChange = (e) => {
    //const { name, value } = e.target;
  };

  const searchData = async (e) => {
    e.preventDefault();
    if( searchTerm.search != ''){
      try {
        //setLoading(true);
        const response = await searchDatasource(searchTerm);
        setDataSourceData(response.data.data);
        //setLoading(false);
      } catch (error) {
        console.error('Error fetching DataSource data:', error);
      }
    }else{
      fetchTableData();
    }
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    setSearchTerm({
      ...searchTerm,
      [name]: value,
    });
  };

  const handlepopupDo = () => {
    setErrors('');
    setShowPopupDo(true)
  };

  const handlepopupIm = () => {
    setErrors('');
    setShowPopupIm(true)
  };

  const handlepopupQa = () => {
    setErrors('');
    setShowPopupQa(true)
  };

  // Get current users based on pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDataSources = newDataSourceData.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
  return (
    <>
        <Header/>
        <div className="container">
          <nav style={{ "--bs-breadcrumb-divider": ">" }} aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="#"></Link>
              </li>
            </ol>
          </nav>
        </div>
        <div className="container pb-4">
          {loading ? (
              <Loader /> // Show the loader while data is loading
            ) : (
            <div className="box-bdr-dash">
              <div className="row">
                <div className="col-md-12">
                  <div className="box mb-2">
                    <div className="fhir-title">
                      <div className='row'>
                        <div className="col-md-12">
                            <div className="col-md-7 left">
                            <span className="pd-overview-count">
                              Data Source
                            </span>
                            </div>
                            <form onSubmit={searchData}>
                              <div className="col-md-2 left">
                                <div className="col-md-10">
                                <input type="text" className={`form-control`} name="search"
                                  placeholder="Search"
                                  value={searchTerm.search}
                                  onChange={handleSearch}
                                />
                                </div>
                              </div>
                              <div className="col-md-1 left">
                              <button type="submit" className="btn btn-primary submit-btn"> Search </button>
                              </div>
                            </form>
                            <div className="col-md-1.5 left">
                              <div className="plus-link plus-btn">
                                <button onClick={() => setShowPopup(true)} className="btn btn-primary submit-btn"> <i className="fa fa-plus"></i> Upload Data </button>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    <div className="table-data-box">
                      <table className="table-content borderd-table">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>File Name</th>
                            <th>Source</th>
                            <th>Created By</th>
                            <th>Updated Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                        {currentDataSources.length > 0 && currentDataSources.map((item, index) => (
                            <tr key={index}>
                              <td>{item.id}</td>
                              <td>{item.filename}</td>
                              <td>{item.source}</td>
                              <td>{item.name} {item.last_name}</td>
                              <td>{item.updated_at}</td>
                              <td>
                                <span className="delete-row cursor" onClick={() => handleDeleteDataSource(item.id)}>
                                  <img src={DeleteImage} alt="Delete" />
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <Pagination
                      itemsPerPage={itemsPerPage}
                      totalItems={newDataSourceData.length}
                      paginate={paginate}
                      currentPage={currentPage}
                    />
                    </div>
                    {showPopup && (
                      <div
                        className="modal fade show"
                        id="testModal"
                        tabIndex="-1"
                        aria-labelledby="testModalLabel"
                        aria-hidden="true"
                        style={{
                          display: "block",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable exe-model">
                          <div className="modal-content">
                            <div className="modal-header headerModel">
                              <h5
                                className="modal-title modaltitle"
                              >
                                Select Data Source
                              </h5>
                              <button
                                type="button"
                                className="btn-close white-text"
                                onClick={() => setShowPopup(false)}
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <div className='row'>
                                <div className='col-md-12'>
                                  <div className='col-md-3 left'>
                                    <div className="App">
                                      <label htmlFor="fileId" onClick={() =>  handlepopupDo()}>
                                        <FiUploadCloud className="upload__icon" />
                                        <p>Document Upload</p>
                                      </label>
                                    </div>
                                  </div>
                                  <div className='col-md-3 left'>
                                    <div className="App">
                                      <label htmlFor="fileId1" onClick={() => handlepopupIm()}>
                                        <FiUploadCloud className="upload__icon" />
                                        <p></p>
                                        <p>Image Upload</p>
                                      </label>
                                    </div>
                                  </div>
                                  <div className='col-md-3 left'>
                                    <div className="App">
                                      <label htmlFor="fileId2">
                                        <FiUploadCloud className="upload__icon" />
                                        <p></p>
                                        <p>Api</p>
                                      </label>
                                    </div>
                                  </div>
                                  <div className='col-md-3 left'>
                                    <div className="App">
                                      <label htmlFor="fileId3" onClick={() => handlepopupQa()} >
                                        <FiUploadCloud className="upload__icon" />
                                        <p></p>
                                        <p>Q&A</p>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer border-0">
                              <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={() => setShowPopup(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {showPopupDo && (
                      <div
                        className="modal fade show"
                        id="DoModal"
                        tabIndex="-1"
                        aria-labelledby="testModalLabel"
                        aria-hidden="true"
                        style={{
                          display: "block",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable exe-model">
                          <div className="modal-content">
                            <div className="modal-header headerModel">
                              <h5
                                className="modal-title"
                              >
                                Upload Document
                              </h5>
                              <button
                                type="button"
                                className="btn-close white-text"
                                onClick={() => setShowPopupDo(false)}
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <form onSubmit={handleSubmit}>
                                <div className="row">
                                  <div className="col-md-12" style={{backgroundColor:"#00305B", textAlign:"center"}}>
                                      <label style={{color: "white"}}>Upload Document</label>
                                  </div>
                                  <div className="col-md-12">
                                    <div className="mb-3">
                                        <label
                                          htmlFor="fileUpload"
                                          className="form-upload-file col-12" >
                                          <div className="main-container">
                                            <div id="dropZone1" className="drop-zone zone-bottom">
                                              <label
                                                htmlFor="fileUpload"
                                                className="drop-zone-icons"
                                              >
                                                <img src={UploadIcon} alt="upload-icon" />
                                              </label>
                                              <input
                                                type="file"
                                                id="fileUpload"
                                                name="file"
                                                accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
                                                onChange={handleFileChange}
                                                style={{display:'none'}}
                                              />
                                              <span className="drop-zone-text">
                                                Drag drop files here or
                                                <label
                                                  htmlFor="fileUpload"
                                                  className="brows-file"
                                                >
                                                   Browse for files
                                                </label>
                                              </span>
                                              {selectedFiles && (
                                                <span className="mleft">
                                                  {selectedFiles.name}
                                                </span>
                                              )}
                                            </div>
                                            {errorMessage && (
                                              <div className="error-message">{errorMessage}</div>
                                            )}
                                          </div>
                                        </label>
                                    </div>
                                  </div>
                                  <div className="form-buttons mtop">
                                    <button
                                      type="submit"
                                      className="btn btn-primary submit-btn"
                                    >
                                      <i className="fa fa-check" /> Submit
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                            <div className="modal-footer border-0">
                              <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={() => setShowPopupDo(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {showPopupIm && (
                      <div
                        className="modal fade show"
                        id="QaModal"
                        tabIndex="-1"
                        aria-labelledby="testModalLabel"
                        aria-hidden="true"
                        style={{
                          display: "block",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable exe-model">
                          <div className="modal-content">
                            <div className="modal-header headerModel">
                              <h5
                                className="modal-title"
                              >
                                Upload Image
                              </h5>
                              <button
                                type="button"
                                className="btn-close white-text"
                                onClick={() => setShowPopupIm(false)}
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <form onSubmit={handleSubmit}>
                                  <div className="row">
                                    <div className="col-md-12" style={{backgroundColor:"#00305B", textAlign:"center"}}>
                                        <label style={{color: "white"}}> Upload Image</label>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="mb-3">
                                        <label
                                            htmlFor="imageUpload"
                                            className="form-upload-file col-12" >
                                            <div className="main-container">
                                              <div id="dropZone" className="drop-zone zone-bottom">
                                                <label
                                                  htmlFor="imageUpload"
                                                  className="drop-zone-icons"
                                                >
                                                  <img src={UploadIcon} alt="upload-icon" />
                                                </label>
                                                <input
                                                  type="file"
                                                  id="imageUpload"
                                                  name="file"
                                                  onChange={handleFileChange}
                                                  style={{display:'none'}}
                                                />
                                                <span className="drop-zone-text">
                                                  Drag drop files here or
                                                  <label
                                                    htmlFor="imageUpload"
                                                    className="brows-file"
                                                  >
                                                    Browse for files
                                                  </label>
                                                </span>
                                                {selectedFiles && (
                                                  <span className="mleft">
                                                    {selectedFiles.name}
                                                  </span>
                                                )}
                                              </div>
                                              {errorMessage && (
                                              <div className="error-message">{errorMessage}</div>
                                            )}
                                            </div>
                                          </label>
                                      </div>
                                    </div>
                                    <div className="form-buttons mtop">
                                      <button
                                        type="submit"
                                        className="btn btn-primary submit-btn"
                                      >
                                        <i className="fa fa-check" /> Submit
                                      </button>
                                    </div>
                                  </div>
                              </form>
                            </div>
                            <div className="modal-footer border-0">
                              <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={() => setShowPopupIm(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {showPopupQa && (
                      <div
                        className="modal fade show"
                        id="QaModal"
                        tabIndex="-1"
                        aria-labelledby="testModalLabel"
                        aria-hidden="true"
                        style={{
                          display: "block",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable exe-model">
                          <div className="modal-content">
                            <div className="modal-header headerModel">
                              <h5
                                className="modal-title"
                              >
                                Add Q/A
                              </h5>
                              <button
                                type="button"
                                className="btn-close white-text"
                                onClick={() => setShowPopupQa(false)}
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                  <div className="row">
                                    <div className="col-md-12">
                                      <div className="mb-3">
                                        <input
                                          type="text"
                                          className={`form-control ${errors.file_name && 'is-invalid'}`}
                                          id="file_nameQa"
                                          name="file_name"
                                          value={formData.file_name}
                                          onChange={handleInputChange}
                                          aria-describedby="text"
                                          placeholder="File Name"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="mb-3">
                                        <input
                                          type="text"
                                          className={`form-control ${errors.description && 'is-invalid'}`}
                                          id="descriptionQa"
                                          name="description"
                                          value={formData.description}
                                          onChange={handleInputChange}
                                          aria-describedby="text"
                                          placeholder="Description"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-12 linediv">
                                      <div className="lineudiv">
                                        <label className="left" style={{color: "white"}}> List</label>
                                        <button
                                          type="button"
                                          className="btn-popup right"
                                          onClick={() => setShowPopupQaDe(true)}
                                        >
                                        Add <i className="fa fa-plus" />
                                        </button>
                                      </div>
                                    </div>
                                    <div className="table-data-box">
                                      <table className="table-content borderd-table">
                                        <thead>
                                          <tr>
                                            <th>Question</th>
                                            <th>Answer</th>
                                            <th>Action</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                        </tbody>
                                      </table>
                                    </div>
                                    <div className="form-buttons mtop">
                                      <button
                                        type="submit"
                                        className="btn btn-primary submit-btn"
                                      >
                                        <i className="fa fa-save" /> Save Data
                                      </button>
                                    </div>
                                  </div>
                              </form>
                            </div>
                            <div className="modal-footer border-0">
                              <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={() => setShowPopupQa(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {showPopupQaDe && (
                      <div
                        className="modal fade show"
                        id="QaDeModal"
                        tabIndex="-1"
                        aria-labelledby="testModalLabel"
                        aria-hidden="true"
                        style={{
                          display: "block",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable exe-model">
                          <div className="modal-content">
                            <div className="modal-header headerModel">
                              <h5
                                className="modal-title"
                              >
                                Add Q/A
                              </h5>
                              <button
                                type="button"
                                className="btn-close white-text"
                                onClick={() => setShowPopupQaDe(false)}
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                  <div className="row">
                                    <div className="col-md-12">
                                      <div className="mb-3">
                                        <input
                                          type="text"
                                          className={`form-control ${errors.question && 'is-invalid'}`}
                                          id="Question"
                                          name="question"
                                          value={formData.file_questionname}
                                          onChange={handleInputChange}
                                          aria-describedby="text"
                                          placeholder="Add Question"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="mb-3">
                                        <input
                                          type="text"
                                          className={`form-control ${errors.answer && 'is-invalid'}`}
                                          id="answer"
                                          name="answer"
                                          value={formData.description}
                                          onChange={handleInputChange}
                                          aria-describedby="text"
                                          placeholder="Add Answer"
                                        />
                                      </div>
                                    </div>
                                    <div className="form-buttons mtop">
                                      <button
                                        type="submit"
                                        className="btn btn-primary submit-btn"
                                      >
                                        <i className="fa fa-save" /> Save Data
                                      </button>
                                    </div>
                                  </div>
                              </form>
                            </div>
                            <div className="modal-footer border-0">
                              <button
                                type="button"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                                onClick={() => setShowPopupQaDe(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {isUploading && (
                      <div style={{ textAlign: 'center', padding: '20px', display:'none' }}>
                      <h1>File Upload with Countdown</h1>
                        <div className="upload-popup">
                          <h3>Uploading your file...</h3>
                          <p>Time remaining: {formatTime(timeLeft)}</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          <style>
        {`
          .upload-popup {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: #f9f9f9;
            padding: 20px;
            border-radius: 8px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            text-align: center;
            z-index: 1000;
          }
          p {
            font-size: 20px;
            font-weight: bold;
            color: #333;
          }
        `}
      </style>
        </div>
    </>
  );
};

export default DataSource;
